import { FC } from 'react'
import { CommandResultsTemplate } from '../../CommandResultsTemplate'
import { BlockContactorResultProps } from './result'
import { ResultTd } from './Result-td'

export const BlockContactorResult: FC<BlockContactorResultProps> = (props) => {
  const { ids, userInputForm } = props
  const pendingQueryName = 'blockDetails'
  const heading = 'CONTACTOR STATE'

  return (
    <CommandResultsTemplate
      ids={ids}
      userInputForm={userInputForm}
      pendingEvaluation={() => {}}
      resultHeading={heading}
      ResultsTd={ResultTd}
      pendingQueryName={pendingQueryName}
    />
  )
}
